import { render } from "./ContactsComponent.vue?vue&type=template&id=0f96231c&scoped=true"
import script from "./ContactsComponent.vue?vue&type=script&lang=js"
export * from "./ContactsComponent.vue?vue&type=script&lang=js"

import "./ContactsComponent.vue?vue&type=style&index=0&id=0f96231c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f96231c"]])

export default __exports__